(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-ui/assets/javascripts/head.js') >= 0) return;  svs.modules.push('/components/chat/chat-ui/assets/javascripts/head.js');

'use strict';

const Head = _ref => {
  let children = _ref.children,
    headline = _ref.headline;
  return React.createElement("div", {
    className: "chat-head"
  }, children, React.createElement("h3", {
    className: "chat-head--title margin-bottom-0"
  }, headline));
};
setGlobal('svs.components.chat.chatUi.Head', Head);

 })(window);